import React from 'react';
import Cita from './Cita';
import PropTypes from 'prop-types';

const ListaCitas = ({ citas, eliminarCita }) => (
    <div className="bg-light p-2">        
        {citas.length === 0 ? 
            <p className="text-center m-0">No hay citas</p>
        : 
            citas.map(cita => (
                <Cita 
                    key={cita.id}
                    cita={cita}
                    eliminarCita={eliminarCita}
                />
            ))
        }
    </div>
);

ListaCitas.propTypes = {
    citas : PropTypes.array.isRequired,
    eliminarCita : PropTypes.func.isRequired
}

export default ListaCitas;